// tracking phone click
$('.call-phone').click(function(e){
	e.stopPropagation();
	gtag('event', 'click',{ 'event_category': 'Phone','non_interaction': true});
}); 
$('#messageus_button').click(function(e){
	e.stopPropagation();
	gtag('event', 'click',{ 'event_category': 'Messenger','non_interaction': true});
});

$('.tierra-zalo-cta').click(function(e){
	e.stopPropagation();
	gtag('event', 'click',{ 'event_category': 'Zalo','non_interaction': true});
});

$('.tierra-contact-mb').click(function(e){
	e.stopPropagation();
	gtag('event', 'click',{ 'event_category': 'ClickContact','non_interaction': true});
});


$('.close-popup').click(function(e){
	e.stopPropagation();
	gtag('event', 'click',{ 'event_category': 'Close Popup','non_interaction': true});
});


// WEBPACK FOOTER //
// ./src/tracking.js